import { useState, useEffect } from "react";
import CloseIcon from '@mui/icons-material/CloseRounded';
import { Button, Modal, Col, Row } from "react-bootstrap";
import _ from "lodash";
import ApiUserTransaction from "../../../core/api/api.userTransaction";
import { useNavigate, useLocation } from "react-router-dom";

// ?????????????????????????????  ویرایش شود
// بر اساس انچه که می خواهیم نمایش دهد
export const ViewModal = () => {
  let location = useLocation();
  let navigate = useNavigate();
  let back = (e) => {
    e.stopPropagation();
    navigate(-1);
  };
  const [itam, setUserTransaction] = useState();


  useEffect(() => {
    (async () => {
      try {
        if (!_.isEmpty(location.state) && _.isNumber(location.state?.id) && location.state?.id > 0) {
          // دریافت اطلاعات کاربر جهت ویرایش
          let response = await ApiUserTransaction.getUserTransactionById(location.state.id);
          if (response.succeeded == true) {
            setUserTransaction(response.data);
            //setValue("roleList", response.data.roleList);
          }
        }
      } catch (error) {
      }
    })();

    return () => { };
  }, []);


  return (
    <div>
      {/* Start Modal */}
      {/* <Modal centered size='md' show={show} onHide={handleClose}> */}
      <Modal centered size='md' show={true} >
        <Modal.Header closeButton>
          <Modal.Title>اطلاعات تراکنش </Modal.Title>
        </Modal.Header>
        <Modal.Body >
          <Col xs='12'>
            <Row>
              <Col xs='12' >
                <div className="font-weight-bold border-bottom  pb-2 mb-3">اطلاعات فردی</div>
              </Col>
              <Col xs="auto">
                نام و نام خانوادگی  : {itam?.userFullName}
              </Col>
              <Col xs="auto">
                شماره همراه  : {itam?.phoneNumber}
              </Col>
            </Row>
            <Row>
              <Col xs='12' >
                <div className="font-weight-bold border-bottom border-top pb-2 mb-3">اطلاعات تراکنش</div>
              </Col>
              <Col xs="auto">
                شماره تراکنش  : {itam?.id}
              </Col>
              <Col xs="auto">
                مبلغ  : {itam?.riallBalance.toLocaleString()}
              </Col>
              <Col xs="auto">
                وضعیت  : {itam?.statusS}
              </Col>
              <Col xs="auto">
                تاریخ انجام  : {itam?.completionDate}
              </Col>
              <Col xs="auto">
                زمان انجام   : {itam?.completionTime}
              </Col>
              <Col xs="auto">
                کد پیگیری  : {itam?.trackingCode}
              </Col>
              <Col xs="auto">
                توضیحات  : {itam?.description}
              </Col>
            </Row>
            {itam?.userPayment ?
              <Row >
                <Col xs='12' >
                  <div className="font-weight-bold border-bottom border-top pb-2 mb-3">اطلاعات پرداخت</div>
                </Col>
                <Col xs="auto">
                  شماره پرداخت  : {itam?.userPayment?.id}
                </Col>
                {itam.riallBalance !== itam.userPayment.rialAmount &&
                  <Col xs="auto" >
                    مبلغ  : {itam?.userPayment?.rialAmount.toLocaleString()}
                  </Col>
                }
                {itam.completionDate !== itam.userPayment.paymentDate &&
                  <Col xs="auto" >
                    تاریخ انجام   : {itam?.userPayment?.paymentDate}
                  </Col>
                }
                {itam.completionTime !== itam.userPayment.paymentTime &&
                  <Col xs="auto" >
                    زمان انجام   : {itam?.userPayment?.paymentTime}
                  </Col>
                }
                <Col xs="auto">
                  شماره کارت پرداخت  : {itam?.userPayment?.cardNumberPayment}
                </Col>
                <Col xs="auto">
                  شماره مرجع (referenceId)  : {itam?.userPayment?.referenceId}
                </Col>
                <Col xs="auto">
                  شماره توکن  : {itam?.userPayment?.tokenNumber}
                </Col>
                <Col xs="auto">
                  شماره ای پی  : {itam?.userPayment?.userIp}
                </Col>
                {itam.description !== itam.userPayment.description &&
                  <Col xs="auto" >
                    توضیحات   : {itam?.userPayment?.description}
                  </Col>
                }
              </Row>
              : <></>}
            {itam?.basket ?
              <Row >
                <Col xs='12' >
                  <div className="font-weight-bold border-bottom border-top pb-2 mb-3">اطلاعات سبد خرید</div>
                </Col>
                <Col xs="auto">
                  شماره سبد  : {itam?.basket?.id}
                </Col>
                <Col xs="auto">
                  مبلغ اصلی  : {itam?.basket?.originalPrice.toLocaleString()}
                </Col>
                <Col xs="auto">
                  مبلغ نهایی  : {itam?.basket?.price.toLocaleString()}
                </Col>
                {/* <Col xs="auto">
                                    وضعیت سبد  : {itam?.basket?.status}
                                </Col> */}
              </Row>
              : <></>}
            {itam?.userWithdrawal ?
              <Row >
                <Col xs='12' >
                  <div className="font-weight-bold border-bottom border-top pb-2 mb-3">اطلاعات درخواست برداشت وجه</div>
                </Col>
                <Col xs="auto">
                  شماره درخواست  : {itam?.userWithdrawal?.id}
                </Col>
                {itam.riallBalance !== itam.userWithdrawal.rialAmount &&
                  <Col xs="auto" >
                    مبلغ  : {itam?.userWithdrawal?.rialAmount.toLocaleString()}
                  </Col>
                }
                {itam.completionDate !== itam.userWithdrawal.paymentDate &&
                  <Col xs="auto" >
                    تاریخ انجام   : {itam?.userWithdrawal?.paymentDate}
                  </Col>
                }
                {itam.completionTime !== itam.userWithdrawal.paymentTime &&
                  <Col xs="auto" >
                    زمان انجام   : {itam?.userWithdrawal?.paymentTime}
                  </Col>
                }
                {/* <Col xs="auto">
                                    وضعیت درخواست  : {itam?.userWithdrawal?.status}
                                </Col> */}
                {itam.userWithdrawal.destinationAccount ?
                  <Row >
                    <Col xs='12' >
                      <div className="   pb-2 mb-3">---- اطلاعات حساب مقصد : </div>
                    </Col>
                    <Col xs="auto" >
                      نام بانک  : {itam.userWithdrawal.destinationAccount.bank}
                    </Col>
                    <Col xs="auto" >
                      نام صاحب حساب  : {itam.userWithdrawal.destinationAccount.accountOwnerName}
                    </Col>
                    <Col xs="auto" >
                      شماره حساب  : {itam.userWithdrawal.destinationAccount.accountNumber}
                    </Col>
                    <Col xs="auto" >
                      نام صاحب کارت  : {itam.userWithdrawal.destinationAccount.cardOwnerName}
                    </Col>
                    <Col xs="auto" >
                      شماره کارت  : {itam.userWithdrawal.destinationAccount.cardNumber}
                    </Col>
                    <Col xs="auto" >
                      شماره شبا  : {itam.userWithdrawal.destinationAccount.shebaNumber}
                    </Col>
                  </Row>
                  : <></>}
              </Row>
              : <></>}
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={back}>
            <CloseIcon />  بستن
                    </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
